/**
 * ProgressBar Component
 * Shows test progress
 */
import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  sectionName: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ 
  current, 
  total, 
  sectionName 
}) => {
  const percentage = Math.round((current / total) * 100);
  
  return (
    <div className="mb-4 bg-white rounded-xl shadow-lg p-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-semibold text-gray-700">
          Question {current}/{total}
        </span>
        <span className="text-sm text-gray-600">
          {percentage}%
        </span>
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-gradient-to-r from-primary to-secondary h-2 rounded-full transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      <p className="text-sm text-gray-500 text-center mt-2">{sectionName}</p>
    </div>
  );
};

export default ProgressBar;
